import React, { type PropsWithChildren } from 'react';
import { ScrollView, StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';

import { useAppLayout } from '../../hooks/useAppLayout';
import { colors } from '../../core/theme/tokens';

type WebScreenBodyProps = PropsWithChildren<{
  style?: StyleProp<ViewStyle>;
  scroll?: boolean;
}>;

/**
 * Web dashboard content area — padded, scrollable, no bottom tab inset.
 * Use inside WebDashboardShell main column.
 */
export function WebScreenBody({ children, style, scroll = true }: WebScreenBodyProps) {
  const { contentPadding } = useAppLayout();

  const content = (
    <View style={[styles.inner, { padding: contentPadding }, style]}>{children}</View>
  );

  if (!scroll) {
    return <View style={styles.root}>{content}</View>;
  }

  return (
    <ScrollView
      style={styles.root}
      contentContainerStyle={styles.scrollContent}
      showsVerticalScrollIndicator={false}
      // Avoid nested/document scroll fighting the tab scene.
      nestedScrollEnabled
    >
      {content}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    minHeight: 0,
    backgroundColor: colors.background,
  },
  scrollContent: {
    flexGrow: 1,
    paddingBottom: 24,
  },
  inner: {
    width: '100%',
    maxWidth: '100%',
    gap: 16,
  },
});
